import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Do you work with Australian licensees and templates?",
    a: "Yes, exclusively. Every SOA is drafted directly into your licensee template, and modeling follows ASIC RG90/RG175 guidance plus your internal compliance guide.",
  },
  {
    q: "What is a typical SOA turnaround time?",
    a: "Standard SOAs land back with you in 2 business days. ROAs in 24 hours. Priority files (1 day SOA / 4 hour ROA) carry a 25% surcharge. Every quote shows the exact turnaround before you commit.",
  },
  {
    q: "How do you handle client data and confidentiality?",
    a: "If you choose to engage, we sign one mutual NDA at the start of our relationship and it covers every file going forward. No new paperwork per SOA. Data is processed in your secure cloud workspaces (Xplan, Xtools+, Adviser Logic), with no local retention on my side. Aligned with APP 8 and the Notifiable Data Breaches scheme.",
  },
  {
    q: "What engagement models do you offer?",
    a: "Flat rate per SOA or ROA, capped at $500 AUD. You only pay for what is delivered, and Approval First billing means you sign off on the draft before any invoice is issued. No retainers, no setup fees.",
  },
  {
    q: "How do you avoid errors that creep into traditional paraplanning?",
    a: "I run Fact Find data through multiple AI models in parallel and cross check outputs against custom Excel models. Where a single human or a single tool can miss a number, cross validation across systems catches it before it ever reaches the draft.",
  },
  {
    q: "Are NDA and SLA mandatory before we start?",
    a: "No. They are optional and entirely your call. Some practices prefer to start with a single trial SOA and add paperwork later. Others want everything locked down up front. Either way, one signature at the start covers the whole engagement.",
  },
];

const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-white border-b-2 border-black"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-28">
        <div className="max-w-2xl">
          <span className="inline-block bg-[#FACC15] border-2 border-black px-3 py-1 text-xs font-bold uppercase tracking-widest shadow-brutal">
            FAQ
          </span>
          <h2 className="font-display font-black mt-4 text-4xl md:text-5xl tracking-tighter leading-[1.05]">
            Answers, before the call.
          </h2>
          <p className="mt-5 text-base md:text-lg text-black/75 leading-relaxed">
            The questions advisers ask most often. Anything else, drop it into the discovery call.
            Happy to dig in.
          </p>
        </div>

        <Accordion type="single" collapsible className="mt-10 space-y-4">
          {faqs.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-2 border-black bg-white shadow-brutal data-[state=open]:shadow-brutal-lg transition-shadow"
            >
              <AccordionTrigger
                className="px-5 py-5 text-left font-display font-bold text-base md:text-lg hover:bg-[#FACC15] hover:no-underline data-[state=open]:bg-[#FACC15] [&[data-state=open]>svg]:text-black"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="px-5 pb-5 text-sm md:text-base text-black/80 leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
